export default __webpack_public_path__ + "static/media/service_cooolmax.744f0887.svg";